export const getRawPhoneNumber = (value: string) => {
  const prefix = value.startsWith('+') ? '+' : '';
  return `${prefix}${value.replace(/\D/g, '')}`;
};

/**
 * Format a phone number for North American presentation.
 * Assumes the country code is +1.
 * @param string Raw phone number, e.g. +11234567890
 * @returns +1 (123) 456-7890
 */
export const presentUsPhoneNumber = (value: string, discardPlus = false) => {
  const hasCountryCode = value.startsWith('+');
  const numbers = value.replace(/\D/g, '');
  const insertChars: Record<number, string> = hasCountryCode
    ? {
        0: discardPlus ? '' : '+',
        1: ' (',
        4: ') ',
        7: '-',
      }
    : {
        0: '(',
        3: ') ',
        6: '-',
      };
  return [...numbers]
    .map((num, i) =>
      Object.prototype.hasOwnProperty.call(insertChars, i)
        ? `${insertChars[i]}${num}`
        : num
    )
    .join('');
};
